export default {
  List: {
    Title: "Quản lý đối soát",

    // Tiêu đề cho cột grid
    TransControlPeriod: "Kỳ đối soát",
    TransControlDate: "Ngày đối soát",
    TransControlSuccessNumber: "Số GD thanh toán thành công",
    TransControlSuccessNumberUp: "Số GD thanh toán",
    TransControlSuccessNumberDown: "thành công",
    TransControlRefundNumber: "Số GD hoàn trả thành công",
    TransControlRefundNumberUp: "Số GD hoàn trả",
    TransControlRefundNumberDown: "thành công",
    TransControlSuccessAmt: "Số tiền thanh toán thành công",
    TransControlSuccessAmtUp: "Số tiền thanh toán",
    TransControlSuccessAmtDown: "thành công",
    TransControlSuccessAmtByMonth: "Giá trị GD thanh toán thành công",
    TransControlSuccessAmtByMonthUp: "Giá trị GD",
    TransControlSuccessAmtByMonthDown: "thanh toán thành công",
    TransControlRefundAmt: "Số tiền hoàn trả thành công",
    TransControlRefundAmtUp: "Số tiền hoàn trả",
    TransControlRefundAmtDown: "thành công",
    TransControlRefundAmtByMonth: "Giá trị GD hoàn trả thành công",
    TransControlRefundAmtByMonthUp: "Giá trị GD",
    TransControlRefundAmtByMonthDown: "hoàn trả thành công",
    TransControlSuccessFee: "Phí thanh toán",
    TransControlRefundFee: "Phí hoàn trả",
    TransControlJetPayPaymentAmt: "Số tiền JetPay thanh toán",
    TransControlJetPayPaymentAmtUp: "Số tiền JetPay",
    TransControlJetPayPaymentAmtDown: "thanh toán",
    Status: "Trạng thái",
    Month: "Tháng",
  },
  Common: {
    OrdinalNumber: "STT",
    TransactionSuccessCurrent: {
      Title: "GD thành công kỳ này",
      Quantity: "Số lượng (2a)",
      Price: "Giá trị (2b)",
      Fee: "Phí (2c)",
    },
    TransactionRefund: {
      Title: "GD hoàn trả",
      Quantity: "Số lượng (3a)",
      Price: "Giá trị (3b)",
      Fee: "Phí (3c)",
    },
    TransactionAdditional: {
      Title: "GD thành công kỳ trước chưa đối soát",
      Quantity: "Số lượng (4a)",
      Price: "Giá trị (4b)",
      Fee: "Phí (4c)",
    },
    TotalFee: "Tổng phí",
    TotalAmountPayment: "Tổng tiền thanh toán cho ĐVCNTT",
    TransactionComplaint: {
      Title: "GD chờ xử lý",
      TotalQuantity: "Tổng số lượng",
      TotalAmount: "Tổng giá trị",
      QuantityOffset: "Số lượng GD bù trừ (8a)",
      AmountOffset: "Giá trị GD bù trừ (8b)",
      QuantityTranshold: "Số lượng GD tạm giữ (7a)",
      AmountTranshold: "Giá trị GD tạm giữ (7b)",
    },
  },
  Detail: {
    OrderId: "Mã đơn hàng",
    Code: "Mã giao dịch",
    RefundCode: "Mã giao dịch hoàn",
    OrgRefundCode: "Mã giao dịch gốc",
    CreatedDate: "Thời gian",
    Amount: "Số tiền",
    FeeAmount: "Phí giao dịch",
  },
  TransactionStatus: {
    PaymentRequired: "Yêu cầu thanh toán",
    HandlingTransaction: "Đang xử lý giao dịch",
    PaymentFail: "Thanh toán thất bại",
    PaymentSuccess: "Thanh toán thành công",
    PaymentExpired: "Hết hạn thanh toán",
    TransactionCancle: "Hủy giao dịch",
  },
  Message: {
    NotEmpty: "Vui lòng nhập thời gian vào ô tìm kiếm",
    FormatDateWrong: "Nhập sai định dạng thời gian. Vui lòng kiểm tra lại",
    FormatDateEmpty: "Vui lòng nhập đủ thời gian lọc",
    DisDateLong: "Khoảng cách Từ ngày - Đến ngày không quá 31 ngày",
    FromDateLong: "Không thể tìm kiếm cách ngày hiện tại quá 180 ngày",
    FromDateLongSixMonth: "Ngày bắt đầu không được quá 6 tháng so với ngày hiện tại",
    FromDateLongTwelveMonth: "Ngày bắt đầu không được quá 12 tháng so với ngày hiện tại",
    DisDateFail: "Từ ngày không được vượt quá Đến ngày",
    DisMonthFail: "Từ tháng không được vượt quá Đến tháng",
    ToDateFail: "Không được tìm kiếm vượt quá ngày hiện tại",
    DisDateWrong: "Chỉ được tìm kiếm kết quả từ một tháng trở về trước",
    DisDateLongSixMonth: "Bạn chỉ xem được các giao dịch trong 6 tháng gần đây",
    DisDateLongV2: "Mỗi lần chỉ được xem giao dịch trong 31 ngày",
  },
};
